'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.operatorInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('../../lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var operatorInvariant = exports.operatorInvariant = function operatorInvariant(operator) {
  return (0, _invariant2.default)(typeof operator === 'function', 'Expected an operator to be a `function` not a `%s`', typeof indexedData === 'undefined' ? 'undefined' : _typeof(indexedData));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/invariants/operatorInvariant.js
// module id = 451
// module chunks = 2 3